import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingCondenseImageConfig } from '@/data/landingConfig/landingCondenseImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_CondenseImage } from './schemaObject';

interface Props {}
const CondenseImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_CondenseImage} />
			<LandingTemplate
				data={landingCondenseImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageCompressor()}
			/>
		</>
	);
};

export default CondenseImage;
